// @flow

import { observer } from "mobx-react";
import React from "react";

import TextFormatter from "app/util/TextFormatter";
import VideoProgressRangeArrow from "app/components/VideoProgressRangeArrow/VideoProgressRangeArrow";
import VideoProgress from "app/components/VideoProgress/VideoProgress";

import "./VideoProgressRange.scss";
import VideoProgressRangeBoundary from "app/components/VideoProgressRangeBoundary/VideoProgressRangeBoundary";
import TimelineItemStore from "../../stores/TimelineItemStore";
import Overlay from "app/components/Overlay/Overlay";

type Props = {
    progress: number,
    duration: number,
    start: number,
    startBoundary?: number,
    stop: number,
    stopBoundary?: number,
    onDrag: Function,
    onDragStop: Function,
    onUpdateStartTime: Function,
    onUpdateStopTime: Function,
    onSeek: Function
};

@observer
export default class VideoProgressRange extends React.Component<Props> {
    timePercentage(time: number) {
        return (time * 100) / this.props.duration + "%";
    }

    handleSeek(time: number) {
        this.props.onSeek(this.props.start + time);
    }

    render() {
        const start = this.props.start;
        const stop = this.props.stop;
        const progress = Math.max(0, this.props.progress - start);
        const duration = stop - start;

        const lengthStyle = {
            left: this.timePercentage(start),
            width: this.timePercentage(stop - start)
        };

        return (
            <div>
                <div className="VideoProgressRange">
                    {this.renderCurrentTimes()}
                    {this.renderBoundaries()}

                    <VideoProgressRangeArrow
                        time={this.props.start}
                        duration={this.props.duration}
                        direction={"left"}
                        onUpdateTime={this.props.onUpdateStartTime}
                        onDragStop={this.props.onDragStop}
                    />

                    <div className="VideoProgressRange__length" style={lengthStyle}>
                        <div className="VideoProgressRange__length__background" />

                        <VideoProgress
                            progress={progress}
                            duration={duration}
                            onSeek={this.handleSeek.bind(this)}
                        />
                    </div>

                    <VideoProgressRangeArrow
                        time={this.props.stop}
                        duration={this.props.duration}
                        direction={"right"}
                        onUpdateTime={this.props.onUpdateStopTime}
                        onDragStop={this.props.onDragStop}
                    />
                </div>
                {this.renderLessThan5Alert()}
            </div>
        );
    }

    renderLessThan5Alert() {
        if (! TimelineItemStore.lessThan5Alert) return null

        return (
            <div className="VideoTitleEditor">
                <Overlay active={true} onClick={() => TimelineItemStore.setLessThan5Alert(false)}/>

                <div className="VideoTitleEditor__body">
                    <button
                        type="button"
                        onClick={() => TimelineItemStore.setLessThan5Alert(false)}
                        className="VideoTitleEditor__cancel"
                    >
                        <i className="fa fa-remove" />
                    </button>

                    <div className="VideoTitleEditor__title">
                        Important note!
                        <p>
                        You're specifying less than 5 seconds for a relevant scene.
                        The Card on the right containing your comments may flash by the reader.
                        </p>
                    </div>

                    <button type="button" className="btn btn-success" onClick={() => TimelineItemStore.setLessThan5Alert(false)}>Got it</button>
                </div>
            </div>
        );
        }

    renderCurrentTimes() {
        const lengthPercentage =
            ((this.props.stop - this.props.start) * 100) / this.props.duration;
        if (lengthPercentage < 6.5) {
            const currentCenterTime =
                this.props.start + (this.props.stop - this.props.start) / 2;
            const style = { left: this.timePercentage(currentCenterTime) };

            return (
                <div
                    className="VideoProgressRange__time VideoProgressRange__time--current"
                    style={style}
                >
                    {TextFormatter.seconds(this.props.start)} -{" "}
                    {TextFormatter.seconds(this.props.stop)}
                </div>
            );
        }

        const leftStyle = { left: this.timePercentage(this.props.start) };
        const rightStyle = { left: this.timePercentage(this.props.stop) };

        return (
            <div>
                <div
                    className="VideoProgressRange__time VideoProgressRange__time--current VideoProgressRange__time--current-left"
                    style={leftStyle}
                >
                    {TextFormatter.seconds(this.props.start)}
                </div>

                <div
                    className="VideoProgressRange__time VideoProgressRange__time--current VideoProgressRange__time--current-right"
                    style={rightStyle}
                >
                    {TextFormatter.seconds(this.props.stop)}
                </div>
            </div>
        );
    }

    renderBoundaries() {
        const start = this.props.start;
        const stop = this.props.stop;

        const startBoundary = this.props.startBoundary;
        const stopBoundary = this.props.stopBoundary;

        if (startBoundary == null || stopBoundary == null) return null;

        const startStyle = { left: this.timePercentage(startBoundary) };
        const stopStyle = { left: this.timePercentage(stopBoundary) };

        return (
            <div>
                <div
                    className="VideoProgressRange__boundary"
                    style={startStyle}
                >
                    <VideoProgressRangeBoundary
                        active={start === startBoundary}
                    />
                </div>

                <div className="VideoProgressRange__boundary" style={stopStyle}>
                    <VideoProgressRangeBoundary
                        active={stop === stopBoundary}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoProgressRange/VideoProgressRange.js